<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Me Voluntariar" :valido="!!igrejaId" max-width="720px">
      <p class="pub-intro">Dados do membro:</p>
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 lg12>
            <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details type="tel" v-model="membro.cpf" @change="consultaCPF(membro.cpf)" append-outer-icon="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>
            <v-text-field light disabled v-model="membro.nome" label="NOME" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light disabled v-model="membro.celula.nome" label="CÉLULA" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Dados do ministério:</p>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-select outlined dense :disabled="membro.nome == ''" v-model="voluntario.ministerioId" :items="ministerios" hide-details item-text="nome" item-value="id" color="#00695C" label="MINISTÉRIO*" no-data-text="Sua igreja ainda não cadastrou ministérios" @input="carregaFuncoes"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-select outlined dense :disabled="voluntario.ministerioId == ''" v-model="voluntario.funcaoId" :items="funcoes" hide-details item-text="nome" item-value="id" color="#00695C" label="FUNÇÃO*" @input="carregaSetores"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-select outlined dense :disabled="voluntario.funcaoId == ''" v-model="voluntario.setorId" :items="setores" hide-details item-text="nome" item-value="id" color="#00695C" label="SETOR*"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <v-data-table v-if="tabela.conteudo.length > 0" :items="tabela.conteudo" :headers="tabela.cabecalho" :items-per-page="tabela.itensPorPagina" hide-default-footer style="border: 1px #aaa solid">
              <template v-slot:top>
                <v-toolbar flat dense color="white" style="border-radius: 10px;">
                  <v-toolbar-title class="textoUser">Ministérios que faço parte</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:[`item.situacao`]="{ item }">
                <td>
                  <v-chip v-if="item.situacao == 'EM_ANALISE'" color="warning"><v-icon left>mdi-alert</v-icon>EM ANÁLISE</v-chip>
                  <v-chip v-if="item.situacao == 'ATIVO'" color="success"><v-icon left>mdi-check-circle</v-icon>ATIVO</v-chip>
                  <v-chip v-if="item.situacao == 'INATIVO'" color="error"><v-icon left>mdi-alert-circle</v-icon>INATIVO</v-chip>
                </td>
              </template>
            </v-data-table>
            <v-alert v-if="membro.nome && tabela.conteudo.length == 0" dense type="warning" style="margin: 0px">No momento, não participa de nenhum ministério</v-alert>
          </v-flex>
        </v-layout>
      </v-container>

      <v-btn dark depressed block rounded color="#00695C" large class="mt-5" @click="salvaVoluntario">Confirmar Cadastro</v-btn>
    </PublicShell>

    <v-dialog v-model="dialogoCadastroConcluido" persistent max-width="500px">
          <v-card>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="vp-texto" style="color:#00695C">Cadastro de voluntário realizado com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="vp-texto" style="color: #666">O CPF informado não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a :href="`/cadastro-membro?igrejaId=${igrejaId}`">Clique aqui</a> e cadastre-se primeiro.<br><br>Depois, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'VoluntarioPublico',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      membro: { nome: '', cpf: '', id: '', celula: { nome: '' } },
      voluntario: { igrejaId: '', membroId: '', ministerioId: '', funcaoId: '', setorId: '', situacao: 'EM_ANALISE' },
      tabela: {
        cabecalho: [
          { text: 'Ministério', value: 'ministerio' },
          { text: 'Função', value: 'funcao' },
          { text: 'Setor', value: 'setor' },
          { text: 'Situação', value: 'situacao' },
        ],
        conteudo: [],
        itensPorPagina: -1,
      },
      ministerios: [],
      funcoes: [],
      setores: [],
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      isLoading: false,
      fullPage: true,
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) this.carregaDados()
  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) {
          this.igreja = response.data
          this.voluntario.igrejaId = response.data.id
        }
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
    async consultaCPF(cpf) {
      const vm = this
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaMembroVoluntario', { cpf: cpf, igrejaId: this.igreja.id })
        .then(response => {
          if (response.data) {
            if (response.data.membro) {
              if (!response.data.membro.celula || response.data.membro.celula.includes('NENHUMA')) {
                vm.$refs.chamaSnackbar.snack('#F9A825', 'Desculpe, necessário estar vinculado a uma célula. Favor procurar seu líder!', 'ATENÇÃO')
              } else {
                this.membro.nome = response.data.membro.nome
                this.membro.celula.nome = response.data.membro.celula.trim()
                this.membro.id = response.data.membro.id
                this.voluntario.membroId = response.data.membro.id
                this.tabela.conteudo = response.data.voluntario
                this.carregaMinisterios()
              }
            } else {
              this.dialogoNaoCadastrado = true
            }
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao consultar o CPF. Tente novamente.', 'ERRO')
        })
    },
    closeDialog() { window.location.reload() },
    async carregaMinisterios() {
      this.voluntario.funcaoId = ''
      this.voluntario.setorId = ''
      await axios.post(baseApiUrl + 'Ministerios/listarPublicos', { igrejaId: this.igreja.id })
        .then(response => { if (response.data.length > 0) this.ministerios = response.data })
    },
    async carregaFuncoes() {
      this.voluntario.funcaoId = ''
      this.voluntario.setorId = ''
      await axios.post(baseApiUrl + 'Funcoes/listarPublicasPorMinisterio', { igrejaId: this.igreja.id, ministerioId: this.voluntario.ministerioId })
        .then(response => { if (response.data.length > 0) this.funcoes = response.data })
    },
    async carregaSetores() {
      this.voluntario.setorId = ''
      await axios.post(baseApiUrl + 'Setores/listarPublicos', { igrejaId: this.igreja.id, ministerioId: this.voluntario.ministerioId, funcaoId: this.voluntario.funcaoId })
        .then(response => { if (response.data.length > 0) this.setores = response.data })
    },
    async salvaVoluntario() {
      const vm = this
      if (!this.voluntario.membroId || !this.voluntario.ministerioId || !this.voluntario.funcaoId || !this.voluntario.setorId) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Preencha todos os campos para continuar!', 'ATENÇÃO')
      } else {
        this.isLoading = true
        await axios.post(baseApiUrl + 'Voluntarios/cadastro', this.voluntario)
          .then(response => {
            if (response.data) {
              if (response.data.mensagem.includes('com sucesso')) {
                this.dialogoCadastroConcluido = true
              } else if (response.data.mensagem.includes('já cadastrado com as mesmas informações')) {
                vm.$refs.chamaSnackbar.snack('#F9A825', 'Já existe um cadastro de voluntário com os mesmos dados informados', 'ATENÇÃO')
              }
              this.isLoading = false
            }
          })
      }
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.vp-texto { font-weight: bold; color: #00253E; font-size: 17px; }
</style>
